var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTags(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tags_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 28.8 49.2",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".tags_svg__st0{fill:#999}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tags_svg__st0",
    d: "M8.9 9.5c0 1.2 0 2.4-.1 3.5 0 .2-.2.5-.5.7-1 .8-1.2 2-.5 2.9.7.9 1.9 1.1 2.8.4.9-.7 1-1.9.2-2.9-.1-.2-.3-.4-.3-.6v-3.2c1.3.5 2.4 1 3.6 1.4 1.5.6 3.1 1.2 4.6 1.9.9.3 1.5.9 1.8 1.8L28 37c.7 2 .1 3.1-1.9 3.8-4.8 1.6-9.6 3.2-14.5 4.8-1.9.6-3.1 0-3.7-1.9C5.4 36.5 2.9 29.2.4 22c-.3-.9-.2-1.7.2-2.4 1.8-2.9 3.5-5.8 5.2-8.8.8-1.1 1.8-1.5 3.1-1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tags_svg__st0",
    d: "M9.3 14.3c-.1-2.5-.1-5.1-.2-7.6-.1-1.1-.9-1.9-2-2.2-1-.2-1.9.1-2.6.9-.6.9-.7 1.9-.2 2.8.3.5.6 1.1 1 1.5.5.6.4 1-.3 1.5-.6-1.1-1.4-2-1.9-3.2-.7-1.8.6-4 2.6-4.5s4.2.8 4.4 2.9c.2 2.3.2 4.6.2 6.9 0 .8 0 1.6-.1 2.4 0 .2-.2.6-.3.6-.2 0-.5-.1-.7-.3-.3-.2-.5-.5-.7-.8-.1-.3-.3-.6-.2-.9.1-.2.5-.2.8-.3 0 .2.1.2.2.3z"
  })));
}
export default SvgTags;